module.exports = __webpack_public_path__ + "img/plus.145bb953.svg";